import { render, staticRenderFns } from "./PopupEditCookie.vue?vue&type=template&id=05538b41&scoped=true&"
import script from "./PopupEditCookie.vue?vue&type=script&lang=js&"
export * from "./PopupEditCookie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05538b41",
  null
  
)

export default component.exports